if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.watchTarget = document.getElementById(this.dataset.watchId);
        this.button = this.querySelector('.sticky-add-to-cart__button');

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateResponsiveVisibility = () => {
          this.style.display = this.mobileQuery.matches ? '' : 'none';
        };
        this.mobileQuery.addEventListener('change', this.updateResponsiveVisibility);
        this.updateResponsiveVisibility();

        if (!this.watchTarget) return;

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const scrolledPastTop = entry.boundingClientRect.top < 0;
            this.classList.toggle('sticky-add-to-cart--visible', !entry.isIntersecting && scrolledPastTop);
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this.watchTarget);

        this.stateObserver = new MutationObserver(() => this.syncButtonState());
        this.stateObserver.observe(this.watchTarget, { attributes: true, attributeFilter: ['disabled'] });

        const sourceText = this.watchTarget.querySelector('span');
        if (sourceText) {
          this.textObserver = new MutationObserver(() => this.syncButtonState());
          this.textObserver.observe(sourceText, { characterData: true, childList: true, subtree: true });
        }

        this.syncButtonState();
      }

      syncButtonState() {
        if (!this.watchTarget || !this.button) return;

        this.button.disabled = this.watchTarget.hasAttribute('disabled');

        const sourceText = this.watchTarget.querySelector('span');
        const destinationText = this.button.querySelector('span');
        if (sourceText && destinationText) {
          destinationText.textContent = sourceText.textContent;
        }
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.updateResponsiveVisibility);
        this.visibilityObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.textObserver?.disconnect();
      }
    }
  );
}
